import SuccessModal from './SuccessModal';

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/SuccessModal/index.js